import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import AjaxCaller from '../ajax-caller';

const PREFIX = '/_c21_/api/v3/cafe-ranking';

export const store = new Vuex.Store({
	state: {
		categories: [],
		selectedCategory: {
			main: '',
			sub: ''
		},

		levels: [],
		selectedLevel: 0,

		ranking: [],
		todayCafe: [],

		sortBy: 'score',

		tiaraObj: {
			mainCategory: { layer: 'rank_cafe_category', desc: '랭킹분류 카테고리' },
			cafeRankInfo: { layer: 'rank_info_btn', desc: '카페랭킹이란? 버튼' },
			rankFilter: { layer: 'rank_type_option', desc: '등급별 정렬' },
			scoreSort: { layer: 'score_sorting_option', desc: '점수순 보기 정렬' },
			rankSort: { layer: 'member_sorting_option', desc: '회원수순 보기 정렬' },
			subCategory: { layer: '2depth_rank_list', desc: '랭킹분류 세부 카테고리' },
			rankingItem: { layer: 'cafe_title', desc: '카페 목록' },
			recommendCafe: { layer: 'recommend_cafe_title', desc: '추천카페' },
			recommendCafePaging: { layer: 'recommend_cafe_more_btn', desc: '추천카페 더보기 버튼' }
		}
	},

	getters: {
		getCategories(state) {
			return state.categories;
		},
		getSubCategories(state) {
			return state.categories.find(v => v.id === state.selectedCategory.main).sub;
		},
		getSelectedCategory(state) {
			return state.selectedCategory;
		},
		getLevels(state) {
			return state.levels.map(v => v.name);
		},
		getRanking(state) {
			return state.sortBy === 'score'
				? state.ranking.sort((a, b) => b.cafeScore - a.cafeScore)
				: state.ranking.sort((a, b) => b.totalMemberCount - a.totalMemberCount);
		},
		getTodayCafe(state) {
			return state.todayCafe;
		},

		getTiaraObj(state) {
			return state.tiaraObj;
		}
	},

	mutations: {
		selectMainCategory(state, id) {
			state.selectedCategory.main = id;
			state.selectedCategory.sub = '';
			state.selectedLevel = 0;
		},
		selectSubCategory(state, id) {
			state.selectedCategory.sub = id;
		},

		setCategories(state, categories) {
			let _categories = categories.map(v => {
				const name = v.name.replace('/', '·');
				return {
					id: v.id,
					name: name,
					sub: v.subCafeCategory.length <= 1
						? []
						: [{ id: '', name: `${name} 전체` }].concat(v.subCafeCategory.map(w => ({
							id: w.id,
							name: w.name.replace('/', '·')
						})))
				};
			});
			_categories = [
				{ id: '', name: '전체', sub: [] },
				{ id: 'soaring', name: '랭킹 급상승', sub: [] }
			].concat(_categories);

			state.categories = _categories;
		},
		setLevels(state, levels) {
			let _levels = levels.reverse();
			_levels.unshift({ name: '전체등급', code: '' });

			state.levels = _levels;
		},
		setSelectedLevel(state, index) {
			state.selectedLevel = index;
		},

		setRanking(state, ranking) {
			state.ranking = ranking;
		},

		setSortOption(state, option) {
			state.sortBy = option;
		},

		setTodayCafe(state, cafes) {
			cafes.sort(() => 0.5 - Math.random());
			// state.todayCafe = cafes;
			state.todayCafe = cafes.slice(0, 9); // TODO: 임시 코드. 서버 업데이트 시 교체해 주세요.
		}
	},

	actions: {
		async loadCategories({ commit }) {
			try {
				commit('setCategories', await AjaxCaller.get(`${PREFIX}/categories`));
			} catch(e) {
				throw e;
			}
		},
		async loadLevels({ commit }) {
			try {
				commit('setLevels', await AjaxCaller.get(`${PREFIX}/levels`));
			} catch(e) {
				throw e;
			}
		},
		async loadRanking({ state, commit }, {category=''}={}) {
			let url;
			const isFilteredByLevel = state.selectedCategory.main === '' && state.selectedLevel !== 0;

			if (isFilteredByLevel) {
				url = `${PREFIX}/cafes-by-level/top/100`;
			} else if (category === 'soaring') {
				url = `${PREFIX}/soaring-cafes/top/100`;
			} else {
				url = `${PREFIX}/cafes-by-category/top/100`;
			}
			const params = Object.assign(
				category ? {categoryId: category} : {},
				isFilteredByLevel ? {cafeLevelCode: state.levels[state.selectedLevel].code} : {}
			);

			try {
				commit('setRanking', await AjaxCaller.get(url, params));
			} catch(e) {
				throw e;
			}
		},
		async loadTodayCafe({ commit }) {
			try {
				const cafes = (await AjaxCaller.get('/_c21_/api/v3/hotissue/cafe')).cafes;
				commit('setTodayCafe', cafes);
			} catch (e) {
				throw e;
			}
		}
	}
});
